import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputSelectOptions,
  CurrencyInputField,
  LoaderButton
} from 'components/molecules'
import {
  CUSTOMER_BANK_NAME,
  TL_BANK
} from 'domains/payment-bank-transfer/constants'
import paymentBankTransferCreateScheme from 'domains/payment-bank-transfer/organisms/create-form/paymentBankTransferCreateScheme'
import PropTypes from 'prop-types'

const propTypes = {
  handleSubmitForm: PropTypes.func
}

const defaultProps = {
  handleSubmitForm: () => {}
}

const BankOthersField = ({ creditBankName }) => {

  if (creditBankName.toLowerCase()!=='others') return null

  const field = (
    <InputField
      type='text'
      name='credit_bank_name_others'
      placeholder='Input Bank Name'
    />
  )

  return field
}

BankOthersField.propTypes = {
  creditBankName: PropTypes.string
}

const PaymentBankTransferCreateForm = ({ handleSubmitForm }) => (
  <Formik
    enableReinitialize={ true }
    initialValues={{
      order_number               : '',
      customer_name              : '',
      customer_email             : '',
      transfer_amount            : '',
      transfer_date              : '',
      credit_bank_name           : '',
      credit_bank_name_others    : '',
      credit_account_name        : '',
      credit_bank_account_number : '',
      debit_tl_bank              : ''
    }}
    validationSchema={ paymentBankTransferCreateScheme }
    onSubmit={ handleSubmitForm }
  >
    {
      (formik) => (
        <Form>
          <InputField
            type='number'
            name='order_number'
            label='Order Number'
            required={ true }
            placeholder='Input Order Number'
          />

          <InputField
            type='text'
            name='customer_name'
            label='Customer Name'
            required={ true }
            placeholder='Input Customer Name'
          />

          <InputField
            type='email'
            name='customer_email'
            label='Customer Email'
            required={ true }
            placeholder='Input Customer Email'
          />

          <CurrencyInputField
            name='transfer_amount'
            label='Transfer Amount'
            required={ true }
          />

          <InputField
            type='date'
            max={ (new Date()).toISOString().split('T')[0] } //set max today, format yyyy-mm-dd
            name='transfer_date'
            label='Transfer Date'
            required={ true }
          />

          <InputField
            type='select'
            name='credit_bank_name'
            label='Bank Name'
            required={ true }
          >
            <InputSelectOptions
              options={ CUSTOMER_BANK_NAME }
            />
          </InputField>

          <BankOthersField creditBankName={ formik.values.credit_bank_name } />

          <InputField
            type='text'
            name='credit_account_name'
            label='Bank Account Holder Name '
            required={ true }
            placeholder='Input Bank Account Holder Name'
          />

          <InputField
            type='select'
            name='debit_tl_bank'
            label='TL Bank Name'
            required={ true }
          >
            <InputSelectOptions
              options={ TL_BANK }
              keyPrefix='tl-bank'
            />
          </InputField>

          <LoaderButton
            color='primary'
            className='w-100'
            type='submit'
            disabled={ formik.isSubmitting }
            isLoading={ formik.isSubmitting }
            text='Create Bank Transfer'
          />

        </Form>
      )
    }
  </Formik>
)

PaymentBankTransferCreateForm.propTypes    = propTypes
PaymentBankTransferCreateForm.defaultProps = defaultProps

export default PaymentBankTransferCreateForm
